import { render } from "./FloattingZalo.vue?vue&type=template&id=1db26fe4&scoped=true"
import script from "./FloattingZalo.vue?vue&type=script&lang=js"
export * from "./FloattingZalo.vue?vue&type=script&lang=js"

import "./FloattingZalo.vue?vue&type=style&index=0&id=1db26fe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db26fe4"]])

export default __exports__